require("gsap/CSSPlugin");

window.$ = window.jQuery = require("jquery");
require("datatables.net");
require("datatables.net-responsive");
// require("datatables.net-fixedheader");

//images
require("../../../images/icons/icon-fb.svg");
require("../../../images/icons/icon-twitter.svg");

var Navigo = require("navigo");
var Handlebars = require("handlebars/runtime");
var results_table_template = require("../templates/results-table.handlebars");
var racer_details_template = require("../templates/racer-details.handlebars");



var initShareButtons = require("../blocks/share");

var page_scroll_position;

if (typeof CUR_RACE_ID !== "undefined") {
	var share_url =
		APP_ROOT +
		"/" +
		LOCALE +
		"/" +
		TRANSLATED_SECTION_NAME +
		"/" +
		CUR_RACE_ID +
		"/" +
		CUR_RACE_SLUG;

	var routeSelect; // Custom select instance for route dropdown
	var results_loading_status = "idle";

	/*
	 * Racer details
	 */
	var loadRacerDetails = function (race_id, racer_id) {
		$.post(
			APP_ROOT +
				"/api/" +
				LOCALE +
				"/v1/results/" +
				race_id +
				"/racer/" +
				racer_id,
			displayRacerDetails,
			"json"
		);
	};

	var displayRacerDetails = function (racer_details) {
		racer_details.app_root = APP_ROOT;

		$(document).ready(function () {
			page_scroll_position = $(document).scrollTop();
			$(document).scrollTop(0);

			var racer_details_html = racer_details_template(racer_details);

			$(".page-content").css({ display: "none" });

			$(".content-wrapper").append(racer_details_html);

			initShareButtons($(".share-race-results"));

			$(".back-button").click(function (e) {
				e.preventDefault();
				router.navigate(router.root, true);
			});
		});
	};

	var getRouteResults = function (race_id, route_id) {
		results_loading_status = "loading_route_data";
		$.post(
			APP_ROOT +
				"/api/" +
				LOCALE +
				"/v1/results/" +
				race_id +
				"/route/" +
				route_id,
			displayRoutesResults,
			"json"
		);
	};

	var displayRoutesResults = function (race_data) {
		/*
		 * Compile results template
		 */
		race_data.APP_ROOT = APP_ROOT;

		var html = results_table_template(race_data);

		$(".race-results-content").empty();

		$(html).appendTo(".race-results-content");

		$("#standard-table tr").click(function (e) {
			router.navigate("racer/" + $(this).data("racer_id"));
		});

		var dataTable = $("#standard-table").DataTable({
			bAutoWidth: false,
			order: [[0, "asc"]],
			responsive: {
				details: false,
			},
			paging: !$("#standard-table").hasClass("no-pagination"),
			fixedHeader: false,
			infoCallback: function (settings, start, end, max, total, pre) {
				return start + "-" + end + " of " + max;
			},
			dom: 't<"table-footer"ip<"dataTables_length">><"clear">',
			drawCallback: function (settings) {
				if (
					$("#standard-table").DataTable().page.info()
						.recordsDisplay == 0
				) {
					$(".table-footer").hide();
				} else {
					$(".table-footer").show();
				}

				if (settings.oPreviousSearch.sSearch.length == 0) {
					// if length == 0 user il filtering but not searching

					// update rows index after filtering
					$("#standard-table")
						.DataTable()
						.column(0, { search: "applied", order: "original" })
						.nodes()
						.each(function (cell, i) {
							cell.innerHTML = i + 1;
						});
				}
			},

			initComplete: function () {
				// console.log($("#standard-table").hasClass("no-pagination"));
				// if ($("#standard-table").hasClass("no-pagination")) {
				// 	$(".table-footer").hide();
				// }
			},
		});

		/*
		 * Search
		 */
		$("#results-search__input").keyup(function () {
			dataTable.search($(this).val()).draw();
		});

		/*
		 * DesktopFilters
		 */
		var $genderFilter = $("#gender-select");
		var $categoryFilter = $("#category-select");

		$genderFilter.on("change", function () {
			dataTable.column(5).search($(this).val()).draw();
		});

		$categoryFilter.on("change", function () {
			dataTable.column(6).search($(this).val()).draw();
		});

		/*
		 * Mobile Filters
		 */

		// gender
		$(".gender-mobile-filter li.filter-value").each(function () {
			$(this).on("click", function (e) {
				e.stopPropagation();

				if ($(this).hasClass("active-filter")) {
					// reset filter
					$(this).removeClass("active-filter");
					setTableFilter(5, "");
				} else {
					$(this).parent().find("li").removeClass("active-filter");
					$(this).addClass("active-filter");

					setTableFilter(5, $(this).data("value"));
				}
			});
		});

		// category
		$(".category-mobile-filter li.filter-value").each(function () {
			$(this).on("click", function (e) {
				e.stopPropagation();

				if ($(this).hasClass("active-filter")) {
					// reset filter
					$(this).removeClass("active-filter");
					setTableFilter(6, "");
				} else {
					$(this).parent().find("li").removeClass("active-filter");
					$(this).addClass("active-filter");

					setTableFilter(6, $(this).data("value"));
				}
			});
		});

		var setTableFilter = function (column_num, value) {
			dataTable.column(column_num).search(value).draw();
		};

		// open filters
		$(".mobile-filters-button").on("click", function () {
			$(".mobile-filters-overlay").addClass("open");
		});

		// apply and close filters
		$(".apply-filters, .mobile-filters-overlay").on("click", function () {
			$(".mobile-filters-overlay").removeClass("open");

			if ($(".mobile-filters-content").find("li.active-filter").length) {
				$(".mobile-filters-button").addClass("filters-enabled");
			} else {
				$(".mobile-filters-button").removeClass("filters-enabled");
			}
		});

		// reset
		$(".reset-filters").on("click", function () {
			setTableFilter(5, "");
			setTableFilter(6, "");
			$(".active-filter").removeClass("active-filter");
		});

		/*
		 *	Results per page menu
		 */
		var $page_length_select = $(
			'<select id="length-select" class="sld-select--no-border"></select>'
		);
		$page_length_select.append('<option value="10">10</option>');
		$page_length_select.append('<option value="25">25</option>');
		$page_length_select.append('<option value="50">50</option>');
		$page_length_select.appendTo(".dataTables_length");
		$(".dataTables_length").append(
			'<div class="select-label">rows per page</div>'
		);

		$page_length_select.on("change", function () {
			dataTable.page.len($(this).val()).draw();
		});

		/*
		 * append pagination commands outside table box
		 */
		$(".table-footer").appendTo(".page-content.page-content--grey");

		results_loading_status = "idle";
	};

	$(document).ready(function () {
		initShareButtons($(".share-race-results"));

		/*
		 * Route selection handling
		 */
		var $routeSelectElement = $("#route-select");
		var enabledOptionsCount = $routeSelectElement.find("option:not([disabled])").length;

		// Attach change listener for loading results when route is selected
		$routeSelectElement.on("change", function () {
			var selectedRouteId = $(this).val();

			if (selectedRouteId && selectedRouteId !== "" && results_loading_status == "idle") {
				results_loading_status = "loading_route_data";
				// Hide the "select a route" splash message
				$('.select-route-splash').hide();
				getRouteResults(CUR_RACE_ID, selectedRouteId);
			}
		});

		if (enabledOptionsCount === 1) {
			// Single route available - auto-select it and load results
			var singleRouteId = $routeSelectElement.find("option:not([disabled])").val();
			if (singleRouteId) {
				// Select the single route in the dropdown
				$routeSelectElement.val(singleRouteId);
				// Auto-load results for this route
				getRouteResults(CUR_RACE_ID, singleRouteId);
			}
		} else if (enabledOptionsCount > 1) {
			// Multiple routes available - show dropdown with selection message
			var v_centred_splat_margin_top =
				($(window).height() -
					$(".main-nav").outerHeight() -
					$(".page-header").outerHeight()) /
					2 -
				$(".select-route-splash").height() / 2;

			if (v_centred_splat_margin_top > 0)
				$(".select-route-splash").css({
					"margin-top": v_centred_splat_margin_top,
				});

			$(".select-route-splash").animate({ opacity: 1 }, 300);
		}
	});

	/*
	 * Results router
	 */
	var router = new Navigo(
		(root =
			APP_ROOT +
			"/" +
			LOCALE +
			"/" +
			TRANSLATED_SECTION_NAME +
			"/" +
			CUR_RACE_ID +
			"/" +
			CUR_RACE_SLUG),
		(useHash = false)
	);

	router
		.on({
			"/racer/:id_racer": function (params) {
				loadRacerDetails(CUR_RACE_ID, params.id_racer);
			},

			"/": function () {
				$(".racer-details").remove();
				$(".page-content").css({ display: "block" });

				setTimeout(function () {
					$(document).scrollTop(page_scroll_position);
				}, 50);
			},
		})
		.resolve();
}
